import React from "react";
import { useMount, useUpdateEffect } from "react-use";
import { useActiveCompany } from "components/companies/ActiveCompanyProvider";
import { initOtelTracing, setCurrentCompanyId } from "lib/instrumentation/otelInstrumentation";

export const OtelProvider = ({ children }: { children: React.ReactNode }) => {
  const { company, loading } = useActiveCompany();

  useMount(() => {
    initOtelTracing();
  });

  useUpdateEffect(() => {
    if (!loading) {
      const companyId = company?.id || "";
      setCurrentCompanyId(companyId);
    }
  }, [company?.id, loading]);

  return <>{children}</>;
};
